var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 73,
    viewBox: "0 0 51 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.7744 12.4852H43.766C43.6171 12.237 43.4185 11.9889 43.1703 11.7407L35.278 3.84833C35.0795 3.64978 34.8313 3.45123 34.5334 3.25269V11.1947C34.5334 11.9392 35.0795 12.4852 35.7744 12.4852Z",
    fill: "#FFBE00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7745 15.811C33.243 15.811 31.2078 13.7759 31.2078 11.2444V2.55782H18.451V6.5288H22.6206V10.6983H18.451V14.8679H22.6206V19.0374H18.451V23.1573H22.6206V27.3268H18.451V31.4964H22.6206V35.5666H18.451V31.3971H14.2815V27.2276H18.451V23.1573H14.2815V18.9878H18.451V14.8182H14.2815V10.6487H18.451V6.47917H14.2815V2.50818H10.8069C9.61559 2.50818 8.52357 2.95491 7.67973 3.79875C6.8359 4.64258 6.38916 5.73461 6.38916 6.9259V45.1963C6.38916 47.6285 8.37465 49.614 10.8069 49.614H40.0433C42.4755 49.614 44.461 47.6285 44.461 45.1963V15.811H35.7745Z",
    fill: "#FFBE00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZip);
export default __webpack_public_path__ + "static/media/zip.ddaebe5012e9c31ebb70bab559bb8372.svg";
export { ForwardRef as ReactComponent };